package org.matthewo.styles

import web.cssom.Transition

fun transitions(vararg transitions: Transition) = transitions.joinToString(", ").unsafeCast<Transition>()
